var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bracket-categories-page",class:_vm.classes},[_c('CitiesList',{attrs:{"title":"Результаты","get-link":_vm.getLink,"final-link":"/brackets/final"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }